import Icon from '../components/Icon.vue'

Icon.register({"codepen":{"width":1792,"height":1792,"paths":[{"d":"M216 1169l603 402v-359l-334-223zM154 1025l193-129-193-129v258zM973 1571l603-402-269-180-334 223v359zM896 1078l272-182-272-182-272 182zM485 803l334-223v-359l-603 402zM1445 896l193 129v-258zM1307 803l269-180-603-402v359zM1792 623v546q0 41-34 64l-819 546q-21 13-43 13t-43-13l-819-546q-34-23-34-64v-546q0-41 34-64l819-546q21-13 43-13t43 13l819 546q34 23 34 64z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/codepen.js
// module id = 828
// module chunks = 0